import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faWalking,
  faTaxi,
  faPaw,
} from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';
import { routes } from '../../config/utility';

const navItems = [
  { icon: faHome, route: routes.dashboard },
  { icon: faWalking, route: routes.walk },
  { icon: faTaxi, route: routes.delivery },
  { icon: faPaw, route: routes.pet },
];

const MobileNavBar = () => {
  const { pathname } = useLocation();
  const activeIndex = navItems.findIndex((i) => i.route === pathname);

  return (
    <div className="fixed bottom-0 w-full z-50 sm:hidden">
           <div className="relative backdrop-blur-lg bg-transparent text-primary flex justify-around items-center py-4 rounded-t-3xl shadow-lg "
      >
        {/* 🔵 Floating bubble */}
        {activeIndex >= 0 && (
          <div
            className="absolute -top-6 w-14 h-14 bg-primary rounded-full shadow-xl flex items-center justify-center text-white text-lg transition-all duration-300 ease-in-out"
            style={{
              left: `${activeIndex * 25 + 12.5}%`,
              transform: 'translateX(-50%)',
            }}
          >
            <FontAwesomeIcon icon={navItems[activeIndex].icon} />
          </div>
        )}

        {/* 🚦 Nav icons */}
        {navItems.map(({ icon, route }, i) => (
          <Link
            to={route}
            key={route}
            className="flex-1 flex justify-center"
          >
            <FontAwesomeIcon
              icon={icon}
              className={`text-lg transition-colors duration-300 ${
                i === activeIndex ? 'text-transparent' : 'text-tblue'
              }`}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MobileNavBar;
